import styled from 'styled-components';
import PageHeaderTenant from './PageHeaderTenant';
import { gridSizes } from 'utils/style';

export default styled(PageHeaderTenant)`
  height: 72px;
  padding: 3.2rem;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: solid 1px var(--grey-mouse);
  background: var(--primary500);

  .page-header {
    &__contact-us {
      color: var(--white);
    }
  }

  svg {
    fill: var(--white);
    height: ${gridSizes('L')};
  }
`;
